/**
 * 结算方式
 */
const types = []
types.push({ 'chineseName': '全部', 'value': null, englishName: 'All' })
types.push({ 'chineseName': '按月结算', 'value': -1, englishName: 'Monthly Settlement' })
types.push({ 'chineseName': '按周结算', 'value': -2, englishName: 'Weekly Settlement' })
types.push({ 'chineseName': '半月结', 'value': -3, englishName: 'Half-monthly Settlement' })
export { types }
